import React from 'react';
import { Box, BoxProps, ButtonBase } from '@mui/material';

type SwitcherButtonProps = {
  title?: string;
  value: string;
  selected: boolean;
  handleValueChange: (value: string) => void;
};

export const SwitcherButton = ({
  title,
  value,
  selected,
  handleValueChange,
}: SwitcherButtonProps) => {
  return (
    <ButtonBase
      onClick={() => handleValueChange(value)}
      sx={{ width: '100%', height: '100%' }}
    >
      <Box
        bgcolor={(theme) => (selected ? theme.palette.primary.main : '')}
        color={(theme) => (selected ? theme.palette.common.white : '')}
        display='flex'
        justifyContent='center'
        alignItems='center'
        width='1000%'
        height='100%'
        sx={{ borderRadius: 50 }}
      >
        {title || value}
      </Box>
    </ButtonBase>
  );
};

type SparkSwitcherProps = {
  firstValue: string;
  secondValue: string;
  defaultValue: string;
  onChange: (selectedValue: string) => void;
  containerStyles?: BoxProps['sx'];
};

function SparkSwitcher({
  firstValue,
  secondValue,
  defaultValue,
  onChange,
  containerStyles,
}: SparkSwitcherProps) {
  const [selectedValue, setSelectedValue] = React.useState<string | null>(null);

  const handleValueChange = (value: string) => {
    setSelectedValue(value);
    onChange(value);
  };

  React.useEffect(() => {
    if (!selectedValue) {
      setSelectedValue(defaultValue || firstValue);
    }
  }, [defaultValue, firstValue, selectedValue]);

  return (
    <Box
      display='flex'
      height='3rem'
      width='50%'
      justifyContent='space-between'
      alignItems='center'
      padding='2px'
      overflow='hidden'
      sx={{
        borderRadius: 50,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (theme) => theme.palette.borderColor,
        ...containerStyles,
      }}
    >
      <SwitcherButton
        value={firstValue}
        selected={selectedValue === firstValue}
        handleValueChange={handleValueChange}
      />
      <SwitcherButton
        value={secondValue}
        selected={selectedValue === secondValue}
        handleValueChange={handleValueChange}
      />
    </Box>
  );
}

export default SparkSwitcher;
